import React, { useState } from "react";
import DayForm from "./DayForm";
import { useParams } from "react-router-dom";
import clinicService from "../../../../../services/clinic.service";
import {toast} from 'react-toastify'

function EachDay({ day, hof, updateHours }) {
  const [isEditing, setIsEditing] = useState(false);
  const {clinicId} = useParams();
  const handleEdit = () => {
    setIsEditing(!isEditing);
  };
  const handleDelete = (hourid)=>{
    const setHr = [hourid]
    clinicService.deleteHours(clinicId,setHr)
    .then(res=>{
       // console.log("Success")
       
        toast.success("Deleted Hour",{
            position:toast.POSITION.BOTTOM_RIGHT
        })

    })
    .catch(err=>{
        //console.log("Error")
        toast.error("Error while Delete",{
            position:toast.POSITION.BOTTOM_RIGHT
        })
    })
  }
  return (
    <>
      <div className="row mb-2">
        
          {isEditing ? (
          <DayForm dayData={day} hof={hof} handleEdit= {handleEdit} updateHours={updateHours}/> 
          ) : (
            <>
              <div className="col-lg-3 col-md-3">
               
                <label className="form-label">{day.day}</label>
              </div>
              <div className="col-lg-3 col-md-3 d-flex justify-content-center">
                <label className="form-label me-1">{day.start} </label>
                -
                <label className="form-label ms-1">{day.end}</label>
              </div>
              <div className="col-lg-2 col-md-2">
              <span>{day.status?"Open":"Closed"} </span>
              </div>
              <div className="col-lg-2 col-md-2">
                <label className="form-label">{day.note}</label>
              </div>
              <div className="col-lg-2 col-md-2 d-flex align-items-center">
                <button className="btn btn-info btn-sm me-2" onClick={() => handleEdit()}>
                    <i className="bi bi-pencil-square"></i>
                </button>
                <button className="btn btn-warning btn-sm" onClick={()=>handleDelete(day.id)}>
                    <i className="bi bi-trash3-fill"></i>
                </button>
                </div>
            </>
          )}
       
       
      </div>
    </>
  );
}

export default EachDay;
